import { getApi } from "./api";
import type { BrowserTitleStatus, Notification } from "./types";

export const showNotification = (notification: Notification): void => getApi().showNotification(notification);

export const showTaskCompletedAnimation = (): void => getApi().showTaskCompletedAnimation();

/** Offers an in-app opt-in, respecting opt-out and today's snooze. Native permission requires confirmation in the dialog. */
export const askForBrowserNotificationPermission = (reason: string): void => getApi().askForBrowserNotificationPermission(reason);

export const updateBrowserTitleStatus = (status: BrowserTitleStatus): void => getApi().updateBrowserTitleStatus(status);
